export function normalizeText(str) {
  return str
    .replace(/\*/g, '') // Remove asterisks
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};
export const openInNewTab = url => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
  if (newWindow) newWindow.opener = null
};

export const stateOrProvinceMap = {
      "Alberta": "AB",
      "British Columbia": "BC",
      "Manitoba": "MB",
      "New Brunswick": "NB",
      "Newfoundland and Labrador": "NL",
      "Nova Scotia": "NS",
      "Ontario": "ON",
      "Prince Edward Island": "PE",
      "Quebec": "QC",
      "Saskatchewan": "SK",
      "Northwest Territories": "NT",
      "Nunavut": "NU",
      "Yukon": "YT",
      "Alabama": "AL",
      "Alaska": "AK",
      "Arizona": "AZ",
      "Arkansas": "AR",
      "California": "CA",
      "Colorado": "CO",
      "Connecticut": "CT",
      "Delaware": "DE",
      "Florida": "FL",
      "Georgia": "GA",
      "Hawaii": "HI",
      "Idaho": "ID",
      "Illinois": "IL",
      "Indiana": "IN",
      "Iowa": "IA",
      "Kansas": "KS",
      "Kentucky": "KY",
      "Louisiana": "LA",
      "Maine": "ME",
      "Maryland": "MD",
      "Massachusetts": "MA",
      "Michigan": "MI",
      "Minnesota": "MN",
      "Mississippi": "MS",
      "Missouri": "MO",
      "Montana": "MT",
      "Nebraska": "NE",
      "Nevada": "NV",
      "New Hampshire": "NH",
      "New Jersey": "NJ",
      "New Mexico": "NM",
      "New York": "NY",
      "North Carolina": "NC",
      "North Dakota": "ND",
      "Ohio": "OH",
      "Oklahoma": "OK",
      "Oregon": "OR",
      "Pennsylvania": "PA",
      "Rhode Island": "RI",
      "South Carolina": "SC",
      "South Dakota": "SD",
      "Tennessee": "TN",
      "Texas": "TX",
      "Utah": "UT",
      "Vermont": "VT",
      "Virginia": "VA",
      "Washington": "WA",
      "West Virginia": "WV",
      "Wisconsin": "WI",
      "Wyoming": "WY",
      "District of Columbia": "DC",
      "American Samoa": "AS",
      "Guam": "GU",
      "Northern Mariana Islands": "MP",
      "Puerto Rico": "PR",
      "U.S. Virgin Islands": "VI"
}

const abbrToState = Object.fromEntries(Object.entries(stateOrProvinceMap).map(([k, v]) => [v, k]));

export function extractStateOrProvince(text) {
  const match = stateOrProvinceMap[text];
  return match ? match : text;
}

export function extractStateOrProvinceFromAbbr(abbr) {
  const match = abbrToState[abbr];
  return match ? match : abbr;
}

export const documentTypeOptions = [
  { key: 'inquiry', value: 'Letter of Inquiry', text: 'Letter of Inquiry' },
  { key: 'proposal', value: 'Proposal', text: 'Proposal' },
  { key: 'thank-you', value: 'Thank You Letter', text: 'Thank You Letter' },
  { key: 'impact-report', value: 'Impact Report Letter', text: 'Impact Report Letter' },
  { key: 'custom-letter', value: 'Custom Letter', text: 'Custom Letter' },
]

export const lettertypesenum = {
  'inquiry': 'Inquiry',
  'proposal': 'Proposal',
  'thank-you': 'ThankYou',
  'impact-report': 'ImpactReport',
  'custom-letter': 'CustomLetter',
}

export const getDocType = (type) => {
  return type === 'custom-letter' ? 'custom-document' : type;
};